import { render, staticRenderFns } from "./SettingsForm.vue?vue&type=template&id=9379c4d2"
import script from "./SettingsForm.vue?vue&type=script&lang=ts"
export * from "./SettingsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports